import { useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";

export function useTermsContent() {
  const { currentLanguage } = useTranslation();
  const [content, setContent] = useState("");

  useEffect(() => {
    generateTermsContent();
  }, [currentLanguage]);

  const generateTermsContent = () => {
    const termsContent = getTermsContent(currentLanguage);
    setContent(termsContent);
  };

  const getTermsContent = (language) => {
    const contents = {
      vi: getVietnameseContent(),
      en: getEnglishContent(),
    };
    return contents[language] || contents.vi;
  };

  const getVietnameseContent = () => {
    return `
        <!-- Section 1: Giới thiệu và Chấp nhận điều khoản -->
        <div class="terms-section" id="section1">
            <h2><span class="section-number">1.</span>Giới thiệu và Chấp nhận điều khoản</h2>
            <p>Điều khoản sử dụng này ("Điều khoản") quy định mối quan hệ pháp lý giữa bạn và VietQubit khi bạn truy cập và sử dụng trang web của chúng tôi tại địa chỉ <u>https://vietqubit.com</u> cùng tất cả các dịch vụ liên quan ("Website"). Khi bạn truy cập, duyệt web hoặc sử dụng bất kỳ tính năng nào trên Website, điều đó có nghĩa bạn đã đọc, hiểu và đồng ý tuân thủ các điều khoản này.</p>

            <p>Chúng tôi hiểu rằng việc đọc các điều khoản pháp lý có thể khá phức tạp, vì vậy chúng tôi đã cố gắng trình bày một cách rõ ràng và dễ hiểu nhất có thể. Nếu bạn có bất kỳ câu hỏi nào, đừng ngần ngại liên hệ với chúng tôi qua email <u>legal@vietqubit.com.</u></p>

            <div class="highlight-box">
                <h4>Lưu ý quan trọng</h4>
                <p>Trong trường hợp bạn không đồng ý với bất kỳ phần nào của Điều khoản này, chúng tôi rất tiếc phải mời bạn ngừng sử dụng Website của chúng tôi.</p>
            </div>
        </div>

        <!-- Section 2: Về VietQubit và Dịch vụ -->
        <div class="terms-section" id="section2">
            <h2><span class="section-number">2.</span>Về VietQubit và Dịch vụ của chúng tôi</h2>
            <p>VietQubit là một nhóm nghiên cứu độc lập chuyên về trí tuệ nhân tạo, được thành lập với sứ mệnh thúc đẩy sự phát triển của AI tại Việt Nam và trên toàn cầu. Thương hiệu là sự kết hợp của Viet (có nghĩa là Việt Nam) và Qubit (có nghĩa là Qubits).</p>

            <div class="highlight-box">
                <h4>Tính độc lập của VietQubit</h4>
                <p>Chúng tôi tự hào là một tổ chức độc lập, không có mối quan hệ ràng buộc thương hiệu với bất kỳ tập đoàn hay công ty nào khác trên thế giới. Chúng tôi hoạt động dựa trên nguồn tài chính riêng, quyên góp, hoặc tài trợ từ các công ty đối tác.</p>
            </div>

            <h3>Dịch vụ chúng tôi cung cấp:</h3>
            <ul class="service-list">
                <li><strong>Thông tin nghiên cứu:</strong> Chia sẻ các kết quả nghiên cứu mới nhất trong lĩnh vực Máy học và Học sâu</li>
                <li><strong>Công bố khoa học:</strong> Các bài báo, công bố đã được bình duyệt và công bố tại các hội nghị, hội thảo quốc tế</li>
                <li><strong>Phần mềm mã nguồn mở:</strong> Các công cụ và thư viện AI/ML được phát triển bởi đội ngũ của chúng tôi</li>
                <li><strong>Bộ dữ liệu nghiên cứu:</strong> Tập dữ liệu được chuẩn hóa phục vụ cho cộng đồng nghiên cứu</li>
                <li><strong>Thông tin về tổ chức:</strong> Giới thiệu về đội ngũ nghiên cứu, các thương hiệu trong hệ sinh thái và đối tác của chúng tôi</li>
            </ul>

            <p>Tất cả các nội dung này được cung cấp với mục đích thúc đẩy sự phát triển của khoa học và công nghệ, đặc biệt trong lĩnh vực AI.</p>
        </div>

        <!-- Section 3: Điều kiện và Quy tắc sử dụng -->
        <div class="terms-section" id="section3">
            <h2><span class="section-number">3.</span>Điều kiện và Quy tắc sử dụng</h2>

            <h3>a. Điều kiện về độ tuổi</h3>
            <p>Để bảo vệ quyền lợi của trẻ em theo các quy định pháp luật quốc tế, chúng tôi yêu cầu:</p>
            <ul>
                <li>Người dùng phải từ 13 tuổi trở lên để sử dụng Website (tuân thủ Đạo luật bảo vệ quyền riêng tư trực tuyến của trẻ em - COPPA của Hoa Kỳ)</li>
                <li>Đối với người dùng tại Liên minh Châu Âu, độ tuổi tối thiểu là 16 tuổi (theo Quy định bảo vệ dữ liệu chung - GDPR)</li>
                <li>Tại Việt Nam, chúng tôi khuyến nghị người dùng dưới 18 tuổi nên có sự đồng ý của cha mẹ hoặc người giám hộ</li>
            </ul>

            <div class="warning-box">
                <h4>Chính sách bảo vệ trẻ em</h4>
                <p>Nếu chúng tôi phát hiện người dùng dưới độ tuổi quy định, chúng tôi sẽ ngay lập tức xóa mọi thông tin cá nhân và chấm dứt quyền truy cập của người dùng đó.</p>
            </div>

            <h3>b. Quy tắc sử dụng chung</h3>
            <p>Chúng tôi tin tưởng vào một cộng đồng văn minh và tôn trọng lẫn nhau. Khi sử dụng Website, bạn đồng ý:</p>

            <div class="data-category">
                <h4>Sử dụng Website một cách có trách nhiệm:</h4>
                <ul>
                    <li>Tuân thủ mọi luật pháp hiện hành của Việt Nam và quốc gia nơi bạn sinh sống</li>
                    <li>Tôn trọng quyền sở hữu trí tuệ của VietQubit và các bên thứ ba</li>
                    <li>Không sử dụng Website cho bất kỳ mục đích bất hợp pháp hoặc gây hại</li>
                    <li>Không cố gắng truy cập trái phép vào hệ thống hoặc dữ liệu không được phép</li>
                </ul>
            </div>

            <div class="data-category">
                <h4>Không thực hiện các hành vi sau:</h4>
                <ul>
                    <li>Sao chép, phân phối hoặc sử dụng nội dung của chúng tôi cho mục đích thương mại mà không có sự cho phép bằng văn bản của chúng tôi</li>
                    <li>Sử dụng các công cụ tự động (bot, crawler, scraper) để thu thập dữ liệu từ Website mà không có sự đồng ý của chúng tôi</li>
                    <li>Tải lên hoặc truyền tải bất kỳ nội dung nào chứa virus, malware hoặc mã độc hại</li>
                    <li>Mạo danh hoặc xuyên tạc mối quan hệ của bạn với VietQubit hoặc bất kỳ cá nhân/tổ chức nào</li>
                    <li>Can thiệp hoặc làm gián đoạn hoạt động bình thường của Website</li>
                    <li>Quấy rối, đe dọa hoặc xâm phạm quyền riêng tư của người dùng khác</li>
                </ul>
            </div>

            <h3>c. Sử dụng cho mục đích nghiên cứu</h3>
            <p>Chúng tôi khuyến khích việc sử dụng các tài nguyên của VietQubit cho mục đích nghiên cứu học thuật. Tuy nhiên, vui lòng:</p>
            <ul>
                <li>Trích dẫn nguồn một cách đầy đủ khi sử dụng dữ liệu hoặc kết quả nghiên cứu của chúng tôi</li>
                <li>Tuân thủ các điều khoản cụ thể của từng tập dữ liệu hoặc phần mềm</li>
                <li>Liên hệ với chúng tôi nếu bạn có kế hoạch sử dụng cho mục đích thương mại</li>
            </ul>
        </div>

        <!-- Section 4: Quyền sở hữu trí tuệ -->
        <div class="terms-section" id="section4">
            <h2><span class="section-number">4.</span>Quyền sở hữu trí tuệ</h2>

            <h3>a. Nội dung thuộc quyền sở hữu của VietQubit</h3>
            <p>Tất cả nội dung trên Website này, bao gồm nhưng không giới hạn ở văn bản, hình ảnh, logo, biểu tượng, mã nguồn, thiết kế giao diện, và các tài liệu nghiên cứu, đều thuộc quyền sở hữu của VietQubit hoặc các bên cấp phép cho chúng tôi. Những nội dung này được bảo vệ bởi luật sở hữu trí tuệ của Việt Nam và các công ước quốc tế về bản quyền.</p>

            <div class="highlight-box">
                <h4>Thương hiệu VietQubit</h4>
                <p>Đặc biệt, thương hiệu "VietQubit" và các thương hiệu liên quan trong hệ sinh thái của chúng tôi (VietQubit, VietQubits, VietBrain, và Talbots) là tài sản quý giá của chúng tôi và được bảo hộ theo luật sở hữu công nghiệp.</p>
            </div>

            <h3>b. Giấy phép sử dụng hạn chế</h3>
            <p>Chúng tôi vui mừng cấp cho bạn một giấy phép có giới hạn, không độc quyền, không thể chuyển nhượng để:</p>
            <ul>
                <li>Xem và tải xuống nội dung cho mục đích cá nhân, phi thương mại</li>
                <li>Chia sẻ liên kết đến Website với người khác</li>
                <li>In ấn các tài liệu cho mục đích tham khảo cá nhân</li>
            </ul>

            <p>Tuy nhiên, giấy phép này không bao gồm quyền:</p>
            <ul>
                <li>Sửa đổi hoặc tạo các tác phẩm phái sinh</li>
                <li>Sử dụng cho mục đích thương mại</li>
                <li>Loại bỏ các thông báo về quyền tác giả hoặc quyền sở hữu</li>
            </ul>

            <h3>c. Phần mềm mã nguồn mở và tập dữ liệu</h3>
            <p>Các phần mềm mã nguồn mở và tập dữ liệu do VietQubit phát triển có thể tuân theo các giấy phép riêng biệt (như MIT, Apache 2.0, GPL, Creative Commons). Vui lòng kiểm tra giấy phép cụ thể đi kèm với từng sản phẩm trước khi sử dụng.</p>

            <div class="note">
                <p>Nếu không có giấy phép cụ thể nào được nêu, vui lòng liên hệ với chúng tôi để được hướng dẫn.</p>
            </div>

            <h3>d. Nội dung do người dùng tạo</h3>
            <p>Trong một số trường hợp, Website có thể cho phép bạn gửi nội dung (như bình luận, phản hồi). Khi bạn gửi nội dung:</p>
            <ul>
                <li>Bạn vẫn giữ quyền sở hữu đối với nội dung của mình</li>
                <li>Bạn cấp cho VietQubit quyền sử dụng, sao chép, hiển thị công khai nội dung đó trên Website</li>
                <li>Bạn cam đoan rằng nội dung không vi phạm quyền của bất kỳ bên thứ ba nào</li>
            </ul>
        </div>

        <!-- Section 5: Bảo vệ dữ liệu cá nhân và Quyền riêng tư -->
        <div class="terms-section" id="section5">
            <h2><span class="section-number">5.</span>Bảo vệ dữ liệu cá nhân và Quyền riêng tư</h2>

            <h3>a. Cam kết bảo vệ dữ liệu</h3>
            <p>VietQubit cam kết bảo vệ quyền riêng tư và dữ liệu cá nhân của bạn theo các tiêu chuẩn cao nhất. Chúng tôi tuân thủ:</p>
            <ul>
                <li>Nghị định 13/2023/NĐ-CP của Việt Nam về bảo vệ dữ liệu cá nhân</li>
                <li>GDPR (General Data Protection Regulation) của Liên minh Châu Âu</li>
                <li>CCPA (California Consumer Privacy Act) của Hoa Kỳ</li>
                <li>Các quy định bảo vệ dữ liệu khác có liên quan</li>
            </ul>

            <h3>b. Dữ liệu chúng tôi thu thập</h3>
            <p>Chúng tôi chỉ thu thập dữ liệu cần thiết để cải thiện trải nghiệm của bạn:</p>

            <div class="data-category">
                <h4>Dữ liệu tự động thu thập:</h4>
                <ul>
                    <li>Địa chỉ IP và thông tin địa lý chung (cấp độ thành phố)</li>
                    <li>Loại trình duyệt, hệ điều hành, thiết bị</li>
                    <li>Thời gian truy cập và các trang đã xem</li>
                    <li>Nguồn truy cập (referrer)</li>
                </ul>
            </div>

            <div class="data-category">
                <h4>Dữ liệu bạn cung cấp (nếu có):</h4>
                <ul>
                    <li>Thông tin liên hệ khi bạn đăng ký nhận tin hoặc liên hệ với chúng tôi</li>
                    <li>Nội dung phản hồi hoặc câu hỏi của bạn</li>
                </ul>
            </div>

            <h3>c. Quyền của bạn đối với dữ liệu cá nhân</h3>
            <p>Theo các quy định pháp luật, bạn có các quyền sau:</p>
            <ul>
                <li><strong>Quyền được biết:</strong> Bạn có thể yêu cầu biết chúng tôi thu thập dữ liệu gì về bạn</li>
                <li><strong>Quyền truy cập:</strong> Nhận bản sao dữ liệu cá nhân của bạn</li>
                <li><strong>Quyền chỉnh sửa:</strong> Yêu cầu sửa đổi dữ liệu không chính xác</li>
                <li><strong>Quyền xóa:</strong> Yêu cầu xóa dữ liệu cá nhân trong một số trường hợp</li>
                <li><strong>Quyền hạn chế xử lý:</strong> Yêu cầu ngừng xử lý dữ liệu của bạn</li>
                <li><strong>Quyền chuyển dữ liệu:</strong> Nhận dữ liệu ở định dạng có thể đọc được bằng máy</li>
                <li><strong>Quyền phản đối:</strong> Phản đối việc xử lý dữ liệu cho một số mục đích</li>
                <li><strong>Quyền rút lại sự đồng ý:</strong> Rút lại sự đồng ý bất cứ lúc nào</li>
            </ul>

            <div class="contact-info">
                <h3>Thực hiện quyền của bạn</h3>
                <p>Để thực hiện các quyền này, vui lòng liên hệ: <u>privacy@vietqubit.com</u></p>
            </div>

            <h3>d. Bảo mật dữ liệu</h3>
            <p>Chúng tôi áp dụng các biện pháp bảo mật tiêu chuẩn công nghiệp:</p>
            <ul>
                <li>Mã hóa SSL/TLS cho mọi kết nối</li>
                <li>Lưu trữ dữ liệu được mã hóa</li>
                <li>Kiểm soát truy cập nghiêm ngặt</li>
                <li>Đánh giá bảo mật định kỳ</li>
                <li>Đào tạo nhân viên về bảo mật thông tin</li>
            </ul>

            <p>Trong trường hợp xảy ra vi phạm dữ liệu, chúng tôi cam kết thông báo cho bạn trong vòng 72 giờ theo quy định của GDPR.</p>
        </div>

        <!-- Section 6: Cookies và Công nghệ theo dõi -->
        <div class="terms-section" id="section6">
            <h2><span class="section-number">6.</span>Cookies và Công nghệ theo dõi</h2>

            <h3>a. Cookies là gì?</h3>
            <p>Cookies là các tệp văn bản nhỏ được lưu trữ trên thiết bị của bạn khi bạn truy cập Website. Chúng giúp Website hoạt động hiệu quả hơn và cung cấp trải nghiệm tốt hơn cho bạn.</p>

            <h3>b. Các loại cookies chúng tôi sử dụng</h3>

            <div class="cookie-type">
                <h4>Cookies thiết yếu:</h4>
                <ul>
                    <li>Cần thiết để Website hoạt động</li>
                    <li>Lưu trữ tùy chọn ngôn ngữ của bạn</li>
                    <li>Duy trì phiên làm việc an toàn</li>
                    <li>Không thể tắt mà không ảnh hưởng đến chức năng cơ bản</li>
                </ul>
            </div>

            <div class="cookie-type">
                <h4>Cookies phân tích:</h4>
                <ul>
                    <li>Google Analytics (với tính năng ẩn danh IP)</li>
                    <li>Microsoft Clarity để hiểu cách người dùng tương tác với Website</li>
                    <li>Chỉ được kích hoạt sau khi có sự đồng ý của bạn</li>
                </ul>
            </div>

            <div class="cookie-type">
                <h4>Cookies chức năng:</h4>
                <ul>
                    <li>Ghi nhớ các tùy chọn của bạn</li>
                    <li>Cải thiện trải nghiệm người dùng</li>
                    <li>Không thu thập thông tin cá nhân định danh</li>
                </ul>
            </div>

            <h3>c. Quản lý cookies</h3>
            <p>Bạn có toàn quyền kiểm soát việc sử dụng cookies:</p>
            <ul>
                <li>Chấp nhận hoặc từ chối thông qua banner thông báo khi lần đầu truy cập</li>
                <li>Thay đổi cài đặt bất cứ lúc nào thông qua trình duyệt</li>
                <li>Xóa cookies đã lưu trữ</li>
            </ul>

            <p>Lưu ý rằng việc vô hiệu hóa một số cookies có thể ảnh hưởng đến trải nghiệm sử dụng Website của bạn.</p>
        </div>

        <!-- Section 7: Liên kết đến Website bên thứ ba -->
        <div class="terms-section" id="section7">
            <h2><span class="section-number">7.</span>Liên kết đến Website bên thứ ba</h2>

            <p>Website của chúng tôi có thể chứa liên kết đến các website khác mà chúng tôi cho rằng hữu ích cho người dùng. Tuy nhiên, xin lưu ý rằng:</p>

            <ul>
                <li>VietQubit không kiểm soát nội dung của các website bên thứ ba</li>
                <li>Chúng tôi không chịu trách nhiệm về chính sách bảo mật hoặc nội dung của họ</li>
                <li>Việc cung cấp liên kết không có nghĩa là chúng tôi xác nhận hoặc đảm bảo cho website đó</li>
            </ul>

            <p>Chúng tôi khuyến nghị bạn nên đọc điều khoản sử dụng và chính sách bảo mật của bất kỳ website nào bạn truy cập từ liên kết trên Website của chúng tôi.</p>
        </div>

        <!-- Section 8: Tuyên bố từ chối trách nhiệm và Giới hạn bảo hành-->
        <div class="terms-section" id="section8">
            <h2><span class="section-number">8.</span>Tuyên bố từ chối trách nhiệm và Giới hạn bảo hành</h2>

            <h3>a. Tính chất "nguyên trạng" của dịch vụ</h3>
            <p>Website và tất cả nội dung được cung cấp trên cơ sở "nguyên trạng" (as-is) và "sẵn có" (as-available). Mặc dù chúng tôi nỗ lực hết sức để đảm bảo thông tin chính xác và cập nhật, chúng tôi không thể đảm bảo:</p>
            <ul>
                <li>Tính chính xác tuyệt đối của mọi thông tin</li>
                <li>Website sẽ hoạt động không gián đoạn hoặc không có lỗi</li>
                <li>Kết quả từ việc sử dụng thông tin sẽ đáp ứng kỳ vọng của bạn</li>
            </ul>

            <h3>b. Về nội dung nghiên cứu</h3>
            <p>Các thông tin nghiên cứu, dữ liệu và phần mềm trên Website:</p>
            <ul>
                <li>Chỉ mang tính chất tham khảo học thuật</li>
                <li>Không thay thế cho lời khuyên chuyên môn</li>
                <li>Có thể chứa lỗi hoặc không phù hợp cho mục đích cụ thể của bạn</li>
                <li>Cần được kiểm tra và xác minh độc lập trước khi sử dụng</li>
            </ul>

            <p>Người dùng hoàn toàn chịu trách nhiệm về việc đánh giá và sử dụng thông tin từ Website.</p>

            <h3>c. Không có bảo hành ngụ ý</h3>
            <p>Trong phạm vi pháp luật cho phép, VietQubit từ chối mọi bảo hành ngụ ý, bao gồm nhưng không giới hạn:</p>
            <ul>
                <li>Bảo hành về khả năng bán được</li>
                <li>Bảo hành về sự phù hợp cho mục đích cụ thể</li>
                <li>Bảo hành về không vi phạm quyền của bên thứ ba</li>
            </ul>
        </div>

        <!-- Section 9: Giới hạn trách nhiệm -->
        <div class="terms-section" id="section9">
            <h2><span class="section-number">9.</span>Giới hạn trách nhiệm</h2>

            <h3>a. Phạm vi giới hạn</h3>
            <p>Trong mọi trường hợp và trong phạm vi tối đa mà pháp luật cho phép, VietQubit, các thành viên, nhân viên, đối tác sẽ không chịu trách nhiệm về:</p>
            <ul>
                <li>Thiệt hại trực tiếp, gián tiếp, ngẫu nhiên, đặc biệt hoặc hậu quả</li>
                <li>Mất mát lợi nhuận, dữ liệu, cơ hội kinh doanh</li>
                <li>Chi phí mua hàng hóa hoặc dịch vụ thay thế</li>
                <li>Thiệt hại phát sinh từ virus, malware hoặc tấn công mạng</li>
            </ul>

            <p>Ngay cả khi VietQubit đã được thông báo về khả năng xảy ra thiệt hại.</p>

            <h3>b. Cơ sở của thỏa thuận</h3>
            <p>Bạn hiểu và đồng ý rằng các giới hạn trách nhiệm này phản ánh sự phân bổ rủi ro hợp lý giữa các bên và là cơ sở quan trọng của thỏa thuận giữa bạn và VietQubit.</p>
        </div>

        <!-- Section 10: Bồi thường -->
        <div class="terms-section" id="section10">
            <h2><span class="section-number">10.</span>Bồi thường</h2>

            <p>Bạn đồng ý bảo vệ, bồi thường và giữ cho VietQubit, các công ty liên kết, giám đốc, nhân viên, đại lý không bị thiệt hại từ bất kỳ khiếu nại, thiệt hại, chi phí (bao gồm phí luật sư hợp lý) phát sinh từ:</p>

            <ul>
                <li>Việc bạn vi phạm Điều khoản này</li>
                <li>Việc bạn vi phạm quyền của bên thứ ba</li>
                <li>Việc sử dụng không đúng Website hoặc dịch vụ</li>
                <li>Nội dung bạn gửi lên hoặc chia sẻ thông qua Website</li>
            </ul>

            <p>Nghĩa vụ bồi thường này sẽ tiếp tục có hiệu lực sau khi Điều khoản chấm dứt.</p>
        </div>

        <!-- Section 11: Chấm dứt sử dụng -->
        <div class="terms-section" id="section11">
            <h2><span class="section-number">11.</span>Chấm dứt sử dụng</h2>

            <h3>a. Quyền chấm dứt của VietQubit</h3>
            <p>Chúng tôi có quyền, theo quyết định riêng của mình, để:</p>
            <ul>
                <li>Tạm ngừng hoặc chấm dứt quyền truy cập của bạn vào Website</li>
                <li>Xóa nội dung vi phạm</li>
                <li>Thực hiện hành động pháp lý nếu cần thiết</li>
            </ul>

            <p>Việc chấm dứt có thể xảy ra ngay lập tức nếu bạn vi phạm nghiêm trọng Điều khoản, hoặc sau khi có thông báo trong các trường hợp khác.</p>

            <h3>b. Quyền của bạn</h3>
            <p>Bạn có thể ngừng sử dụng Website bất cứ lúc nào. Nếu bạn muốn xóa dữ liệu cá nhân, vui lòng liên hệ với chúng tôi theo hướng dẫn trong phần Bảo vệ dữ liệu.</p>

            <h3>c. Hiệu lực sau chấm dứt</h3>
            <p>Các điều khoản về quyền sở hữu trí tuệ, giới hạn trách nhiệm, bồi thường và các điều khoản khác về bản chất cần tiếp tục có hiệu lực sẽ vẫn có giá trị sau khi chấm dứt.</p>
        </div>

        <!-- Section 12: Thay đổi điều khoản -->
        <div class="terms-section" id="section12">
            <h2><span class="section-number">12.</span>Thay đổi điều khoản</h2>

            <h3>a. Quyền sửa đổi</h3>
            <p>VietQubit có quyền cập nhật hoặc sửa đổi Điều khoản này bất cứ lúc nào để:</p>
            <ul>
                <li>Tuân thủ thay đổi pháp luật</li>
                <li>Phản ánh thay đổi trong dịch vụ</li>
                <li>Cải thiện sự rõ ràng hoặc sửa lỗi</li>
                <li>Bảo vệ quyền lợi người dùng tốt hơn</li>
            </ul>

            <h3>b. Thông báo thay đổi</h3>
            <p>Khi có thay đổi quan trọng, chúng tôi sẽ:</p>
            <ul>
                <li>Cập nhật ngày "Cập nhật lần cuối" ở đầu trang</li>
                <li>Hiển thị thông báo trên Website</li>
                <li>Gửi email thông báo (nếu bạn đã đăng ký)</li>
            </ul>

            <p>Việc tiếp tục sử dụng Website sau khi thay đổi có hiệu lực đồng nghĩa với việc bạn chấp nhận Điều khoản mới.</p>
        </div>

        <!-- Section 13: Luật điều chỉnh và Giải quyết tranh chấp -->
        <div class="terms-section" id="section13">
            <h2><span class="section-number">13.</span>Luật điều chỉnh và Giải quyết tranh chấp</h2>

            <h3>a. Luật áp dụng</h3>
            <p>Điều khoản này được điều chỉnh và giải thích theo:</p>
            <ul>
                <li>Luật pháp Việt Nam là luật chính điều chỉnh</li>
                <li>Tuân thủ GDPR cho người dùng tại EU/EEA</li>
                <li>Tuân thủ luật địa phương của quốc gia người dùng khi cần thiết</li>
            </ul>

            <p>Trong trường hợp có xung đột giữa các hệ thống pháp luật, chúng tôi sẽ áp dụng quy định bảo vệ cao nhất cho người dùng.</p>

            <h3>b. Giải quyết tranh chấp</h3>
            <p>Chúng tôi tin vào việc giải quyết mọi bất đồng thông qua đối thoại:</p>

            <div class="step-process">
                <div class="step">
                    <h4>Bước 1: Thương lượng trực tiếp</h4>
                    <ul>
                        <li>Liên hệ với chúng tôi qua <u>legal@vietqubit.com</u></li>
                        <li>Chúng tôi cam kết phản hồi trong 15 ngày làm việc</li>
                        <li>Cùng tìm giải pháp thỏa đáng cho cả hai bên</li>
                    </ul>
                </div>

                <div class="step">
                    <h4>Bước 2: Hòa giải</h4>
                    <ul>
                        <li>Nếu không thể thỏa thuận, có thể chọn hòa giải</li>
                        <li>Chi phí hòa giải được chia đều</li>
                    </ul>
                </div>

                <div class="step">
                    <h4>Bước 3: Tòa án có thẩm quyền</h4>
                    <ul>
                        <li>Tòa án có thẩm quyền tại TP. Hồ Chí Minh, Việt Nam</li>
                        <li>Người dùng Hoa Kỳ hoặc EU có quyền khiếu kiện tại tòa án địa phương</li>
                    </ul>
                </div>
            </div>

            <h3>c. Quyền khiếu nại cho người dùng Hoa Kỳ hoặc EU</h3>
            <p>Người dùng tại Hoa Kỳ hoặc EU có quyền khiếu nại với cơ quan bảo vệ dữ liệu địa phương nếu cho rằng quyền của mình bị vi phạm.</p>
        </div>

        <!-- Section 14: Các điều khoản Khác -->
        <div class="terms-section" id="section14">
            <h2><span class="section-number">14.</span>Các điều khoản Khác</h2>

            <h3>a. Toàn bộ thỏa thuận</h3>
            <p>Điều khoản này, cùng với Chính sách bảo mật của chúng tôi, tạo thành toàn bộ thỏa thuận giữa bạn và VietQubit về việc sử dụng Website. Nó thay thế mọi thỏa thuận hoặc hiểu biết trước đó.</p>

            <h3>b. Tính độc lập của điều khoản</h3>
            <p>Nếu bất kỳ điều khoản nào bị tòa án có thẩm quyền tuyên bố là vô hiệu hoặc không thể thi hành, các điều khoản còn lại vẫn tiếp tục có hiệu lực đầy đủ. Điều khoản vô hiệu sẽ được sửa đổi ở mức tối thiểu cần thiết để có hiệu lực.</p>

            <h3>c. Không từ bỏ quyền</h3>
            <p>Việc VietQubit không thực thi hoặc chậm thực thi bất kỳ quyền nào không được coi là từ bỏ quyền đó. Mọi sự từ bỏ quyền phải được thực hiện bằng văn bản và có chữ ký của đại diện có thẩm quyền của VietQubit.</p>

            <h3>d. Chuyển nhượng</h3>
            <p>Bạn không được chuyển nhượng quyền hoặc nghĩa vụ của mình theo Điều khoản này cho bất kỳ bên thứ ba nào mà không có sự đồng ý trước bằng văn bản của VietQubit. VietQubit có thể chuyển nhượng quyền và nghĩa vụ của mình mà không cần sự đồng ý của bạn.</p>

            <h3>e. Thông báo</h3>
            <p>Mọi thông báo theo Điều khoản này phải được gửi:</p>
            <ul>
                <li>Cho VietQubit: Qua email đến <u>legal@vietqubit.com</u> hoặc địa chỉ được công bố trên Website</li>
                <li>Cho bạn: Qua email bạn cung cấp hoặc thông báo trên Website</li>
            </ul>

            <h3>f. Hiệu lực ràng buộc</h3>
            <p>Điều khoản này có hiệu lực ràng buộc và mang lại lợi ích cho các bên và những người kế thừa, người được chuyển nhượng hợp pháp của họ.</p>
        </div>

        <!-- Section 15: Thông tin liên hệ -->
        <div class="terms-section" id="section15">
            <h2><span class="section-number">15.</span>Thông tin liên hệ</h2>
            <p>Chúng tôi luôn sẵn sàng lắng nghe và hỗ trợ bạn. Nếu có bất kỳ câu hỏi, ý kiến hoặc quan ngại nào về Điều khoản sử dụng này, vui lòng liên hệ với chúng tôi:</p>

            <div class="contact-info">
                <h3>Thông tin chung</h3>
                <p><strong>VietQubit - Trung tâm nghiên cứu VietQubit</strong></p>
                <ul>
                    <li>Website: <u>https://vietqubit.com</u></li>
                    <li>Email chung: <u>contact@vietqubit.com</u></li>
                    <li>Email pháp lý: <u>legal@vietqubit.com</u></li>
                </ul>
            </div>

            <div class="contact-info">
                <h3>Về bảo vệ dữ liệu</h3>
                <p><strong>Người phụ trách bảo vệ dữ liệu</strong></p>
                <ul>
                    <li>Email bảo mật: <u>privacy@vietqubit.com</u></li>
                </ul>
            </div>

            <div class="response-time">
                <h4>Giờ làm việc và thời gian phản hồi</h4>
                <ul>
                    <li><strong>Giờ làm việc:</strong> Thứ Hai - Thứ Sáu: 9:00 - 17:00 (GMT+7)</li>
                    <li><strong>Nghỉ:</strong> Thứ Bảy, Chủ Nhật và ngày lễ</li>
                    <li><strong>Phản hồi thông thường:</strong> 3 - 5 ngày làm việc</li>
                    <li><strong>Vấn đề khẩn cấp:</strong> 24 - 72 giờ</li>
                </ul>
            </div>
        </div>

        <!-- Section 16: Lời kết -->
        <div class="terms-section" id="section16">
            <h2><span class="section-number">16.</span>Lời kết</h2>
            <p>Cảm ơn bạn đã dành thời gian đọc Điều khoản sử dụng của chúng tôi. Chúng tôi hiểu rằng đây là một tài liệu dài, nhưng việc hiểu rõ quyền và trách nhiệm của mỗi bên là rất quan trọng để xây dựng một mối quan hệ tin cậy.</p>

            <div class="commitment-box">
                <h3>VietQubit cam kết:</h3>
                <ul>
                    <li>Luôn minh bạch trong mọi hoạt động</li>
                    <li>Tôn trọng quyền riêng tư và dữ liệu của bạn</li>
                    <li>Cung cấp nội dung chất lượng cao cho cộng đồng</li>
                    <li>Lắng nghe và cải thiện dựa trên phản hồi của người dùng</li>
                </ul>
            </div>

            <p>Chúng tôi tin rằng AI có thể mang lại những thay đổi tích cực cho xã hội, và chúng tôi rất vinh dự được có bạn đồng hành trong hành trình này.</p>

            <div class="highlight-box">
                <h4>Tương lai của AI tại Việt Nam</h4>
                <p>Với sự hỗ trợ của cộng đồng như bạn, chúng tôi tin tưởng rằng Việt Nam sẽ trở thành một trung tâm nghiên cứu AI hàng đầu trong khu vực và trên thế giới.</p>
            </div>
        </div>
    `;
  };

  const getEnglishContent = () => {
    return `
        <!-- Section 1: Introduction and Acceptance of terms -->
        <div class="terms-section" id="section1">
            <h2><span class="section-number">1.</span>Introduction and Acceptance of terms</h2>
            <p>These Terms of Use ("Terms") govern the legal relationship between you and VietQubit when you access and use our website at <u>https://vietqubit.com</u>, together with all related services (the "Website"). By accessing, browsing, or using any feature of the Website, you acknowledge that you have read, understood, and agree to be bound by these Terms.</p>

            <p>We understand that legal documents can be complex, so we have made every effort to present this information as clearly and accessibly as possible. If you have any questions, please do not hesitate to contact us at <u>legal@vietqubit.com</u>.</p>

            <div class="highlight-box">
                <h4>Important notice</h4>
                <p>If you do not agree with any part of these Terms, you should discontinue using our Website.</p>
            </div>
        </div>

        <!-- Section 2: About VietQubit and Our services -->
        <div class="terms-section" id="section2">
            <h2><span class="section-number">2.</span>About VietQubit and Our services</h2>
            <p>VietQubit is an independent research group specializing in artificial intelligence, established with the mission of advancing AI development in Vietnam and around the world. The brand name combines Viet (referring to Vietnam) and Qubit (referring to Qubits).</p>

            <div class="highlight-box">
                <h4>VietQubit's independence</h4>
                <p>We are proud to be an independent organization with no binding brand relationship with any other corporation or company worldwide. We operate based on our own financial resources, donations, and sponsorships from partner companies.</p>
            </div>

            <h3>Services we provide:</h3>
            <ul class="service-list">
                <li><strong>Research information:</strong> Sharing the latest research outcomes in Machine Learning and Deep Learning</li>
                <li><strong>Scientific publications:</strong> Peer-reviewed papers and publications presented at international conferences and workshops</li>
                <li><strong>Open-source software:</strong> AI/ML tools and libraries developed by our team</li>
                <li><strong>Research datasets:</strong> Standardized datasets made available to the research community</li>
                <li><strong>Organizational information:</strong> Introducing our research team, ecosystem brands, and partners</li>
            </ul>

            <p>All of this content is provided to foster the development of science and technology, especially in the field of AI.</p>
        </div>

        <!-- Section 3: Conditions and Rules of use -->
        <div class="terms-section" id="section3">
            <h2><span class="section-number">3.</span>Conditions and Rules of use</h2>

            <h3>a. Age requirements</h3>
            <p>To protect children's rights in accordance with international legal standards, we require that:</p>
            <ul>
                <li>Users must be at least 13 years old to use the Website (in line with the U.S. Children's Online Privacy Protection Act - COPPA)</li>
                <li>For users in the European Union, the minimum age is 16 (pursuant to the General Data Protection Regulation - GDPR)</li>
                <li>In Vietnam, we recommend that users under 18 obtain consent from a parent or legal guardian</li>
            </ul>

            <div class="warning-box">
                <h4>Child protection policy</h4>
                <p>If we become aware that a user is below the required age, we will immediately delete all personal data associated with that user and terminate access to the Website.</p>
            </div>

            <h3>b. General rules of use</h3>
            <p>We believe in a respectful and responsible community. By using the Website, you agree to:</p>

            <div class="data-category">
                <h4>Use the Website responsibly:</h4>
                <ul>
                    <li>Comply with all applicable laws of Vietnam and the country in which you reside</li>
                    <li>Respect the intellectual property rights of VietQubit and third parties</li>
                    <li>Not use the Website for any illegal or harmful purposes</li>
                    <li>Not attempt to gain unauthorized access to systems or data</li>
                </ul>
            </div>

            <div class="data-category">
                <h4>Refrain from the following activities:</h4>
                <ul>
                    <li>Copying, distributing, or using our content for commercial purposes without our prior written consent</li>
                    <li>Using automated tools (bots, crawlers, scrapers) to collect data from the Website without our consent</li>
                    <li>Uploading or transmitting any content that contains viruses, malware, or malicious code</li>
                    <li>Impersonating or misrepresenting your relationship with VietQubit or any individual/organization</li>
                    <li>Interfering with or disrupting the normal operation of the Website</li>
                    <li>Harassing, threatening, or infringing on the privacy of other users</li>
                </ul>
            </div>

            <h3>c. Use for research purposes</h3>
            <p>We encourage the use of VietQubit resources for academic and research purposes. However, please:</p>
            <ul>
                <li>Properly cite the source when using our data or research results</li>
                <li>Comply with specific terms attached to each dataset or software package</li>
                <li>Contact us if you intend to use our resources for commercial purposes</li>
            </ul>
        </div>

        <!-- Section 4: Intellectual property rights -->
        <div class="terms-section" id="section4">
            <h2><span class="section-number">4.</span>Intellectual property rights</h2>

            <h3>a. Content owned by VietQubit</h3>
            <p>All content on this Website, including but not limited to text, images, logos, icons, source code, user interface designs, and research materials, is owned by VietQubit or our licensors. This content is protected under Vietnamese intellectual property laws and applicable international copyright conventions.</p>

            <div class="highlight-box">
                <h4>The VietQubit brand</h4>
                <p>In particular, the "VietQubit" brand and other brands within our ecosystem (such as VietQubit, VietQubits, VietBrain, and Talbots) are valuable assets and are protected under industrial property and trademark laws.</p>
            </div>

            <h3>b. Limited license</h3>
            <p>We grant you a limited, non-exclusive, non-transferable license to:</p>
            <ul>
                <li>View and download content for personal, non-commercial purposes</li>
                <li>Share links to the Website with others</li>
                <li>Print materials for personal reference</li>
            </ul>

            <p>This license does not include the right to:</p>
            <ul>
                <li>Modify content or create derivative works</li>
                <li>Use content for commercial purposes</li>
                <li>Remove copyright or ownership notices</li>
            </ul>

            <h3>c. Open-source software and datasets</h3>
            <p>Open-source software and datasets developed by VietQubit may be subject to separate licenses (such as MIT, Apache 2.0, GPL, or Creative Commons). Please review the specific license associated with each product before use.</p>

            <div class="note">
                <p>If no specific license is indicated, please contact us for guidance before using the material.</p>
            </div>

            <h3>d. User-generated content</h3>
            <p>In some cases, the Website may allow you to submit content (such as comments or feedback). When you submit content:</p>
            <ul>
                <li>You retain ownership of your content</li>
                <li>You grant VietQubit a license to use, reproduce, and publicly display that content on the Website</li>
                <li>You represent and warrant that the content does not infringe any third-party rights</li>
            </ul>
        </div>

        <!-- Section 5: Personal data protection and Privacy -->
        <div class="terms-section" id="section5">
            <h2><span class="section-number">5.</span>Personal data protection and Privacy</h2>

            <h3>a. Our commitment to data protection</h3>
            <p>VietQubit is committed to protecting your privacy and personal data in accordance with the highest standards. We comply with:</p>
            <ul>
                <li>Decree 13/2023/NĐ-CP of Vietnam on personal data protection</li>
                <li>The EU General Data Protection Regulation (GDPR)</li>
                <li>The California Consumer Privacy Act (CCPA)</li>
                <li>Other applicable data protection regulations</li>
            </ul>

            <h3>b. Data we collect</h3>
            <p>We only collect the data necessary to improve your experience:</p>

            <div class="data-category">
                <h4>Data collected automatically:</h4>
                <ul>
                    <li>IP address and general geographic information (city level)</li>
                    <li>Browser type, operating system, and device information</li>
                    <li>Access time and pages viewed</li>
                    <li>Referring sources (referrers)</li>
                </ul>
            </div>

            <div class="data-category">
                <h4>Data you provide (if any):</h4>
                <ul>
                    <li>Contact information when you subscribe, register, or contact us</li>
                    <li>The content of your feedback or inquiries</li>
                </ul>
            </div>

            <h3>c. Your rights regarding personal data</h3>
            <p>Under applicable laws, you may have the following rights:</p>
            <ul>
                <li><strong>Right to be informed:</strong> You can request information about the data we collect about you</li>
                <li><strong>Right of access:</strong> You can obtain a copy of your personal data</li>
                <li><strong>Right to rectification:</strong> You can request correction of inaccurate data</li>
                <li><strong>Right to erasure:</strong> You can request deletion of your personal data in certain circumstances</li>
                <li><strong>Right to restriction of processing:</strong> You can request that we limit the processing of your data</li>
                <li><strong>Right to data portability:</strong> You can receive your data in a machine-readable format</li>
                <li><strong>Right to object:</strong> You can object to certain types of data processing</li>
                <li><strong>Right to withdraw consent:</strong> You can withdraw your consent at any time</li>
            </ul>

            <div class="contact-info">
                <h3>Exercising your rights</h3>
                <p>To exercise these rights, please contact us at: <u>privacy@vietqubit.com</u></p>
            </div>

            <h3>d. Data security</h3>
            <p>We implement industry-standard security measures, including:</p>
            <ul>
                <li>SSL/TLS encryption for all connections</li>
                <li>Encrypted data storage</li>
                <li>Strict access controls</li>
                <li>Periodic security assessments</li>
                <li>Staff training on information security</li>
            </ul>

            <p>In the event of a data breach, we are committed to notifying you within 72 hours, where required by GDPR.</p>
        </div>

        <!-- Section 6: Cookies and Tracking technologies -->
        <div class="terms-section" id="section6">
            <h2><span class="section-number">6.</span>Cookies and Tracking technologies</h2>

            <h3>a. What are cookies?</h3>
            <p>Cookies are small text files stored on your device when you visit a website. They help the Website function properly and provide you with a better user experience.</p>

            <h3>b. Types of cookies we use</h3>

            <div class="cookie-type">
                <h4>Essential cookies:</h4>
                <ul>
                    <li>Required for the Website to function</li>
                    <li>Store your language preferences</li>
                    <li>Maintain secure sessions</li>
                    <li>Cannot be disabled without affecting core functionality</li>
                </ul>
            </div>

            <div class="cookie-type">
                <h4>Analytics cookies:</h4>
                <ul>
                    <li>Google Analytics (with IP anonymization enabled)</li>
                    <li>Microsoft Clarity to better understand how users interact with the Website</li>
                    <li>Activated only with your consent</li>
                </ul>
            </div>

            <div class="cookie-type">
                <h4>Functional cookies:</h4>
                <ul>
                    <li>Remember your preferences</li>
                    <li>Improve your overall user experience</li>
                    <li>Do not collect personally identifiable information</li>
                </ul>
            </div>

            <h3>c. Managing cookies</h3>
            <p>You have full control over cookie usage:</p>
            <ul>
                <li>Accept or decline cookies via the banner shown on your first visit</li>
                <li>Change your browser settings at any time</li>
                <li>Delete cookies stored on your device</li>
            </ul>

            <p>Please note that disabling certain cookies may affect your experience on the Website.</p>
        </div>

        <!-- Section 7: Links to third-party websites -->
        <div class="terms-section" id="section7">
            <h2><span class="section-number">7.</span>Links to third-party websites</h2>

            <p>Our Website may contain links to other websites that we believe may be useful to users. However, please note that:</p>

            <ul>
                <li>VietQubit does not control the content of third-party websites</li>
                <li>We are not responsible for their privacy practices or content</li>
                <li>The inclusion of a link does not imply endorsement or guarantee of that website</li>
            </ul>

            <p>We encourage you to read the terms of use and privacy policy of any website you visit via links from our Website.</p>
        </div>

        <!-- Section 8: Disclaimer and Warranty limitations -->
        <div class="terms-section" id="section8">
            <h2><span class="section-number">8.</span>Disclaimer and Warranty limitations</h2>

            <h3>a. "As-is" nature of the services</h3>
            <p>The Website and all content are provided on an "as-is" and "as-available" basis. While we make every effort to ensure that the information is accurate and up to date, we do not warrant that:</p>
            <ul>
                <li>All information is absolutely accurate, complete, or error-free</li>
                <li>The Website will be uninterrupted or free from errors</li>
                <li>The results obtained from using the information will meet your expectations</li>
            </ul>

            <h3>b. Research content</h3>
            <p>The research information, data, and software available on the Website:</p>
            <ul>
                <li>Are intended for academic and informational purposes only</li>
                <li>Do not constitute professional advice</li>
                <li>May contain errors or may not be suitable for your specific purposes</li>
                <li>Should be independently reviewed and validated before use</li>
            </ul>

            <p>You are solely responsible for evaluating and using the information from the Website.</p>

            <h3>c. No implied warranties</h3>
            <p>To the fullest extent permitted by law, VietQubit disclaims all implied warranties, including but not limited to:</p>
            <ul>
                <li>Implied warranties of merchantability</li>
                <li>Implied warranties of fitness for a particular purpose</li>
                <li>Implied warranties of non-infringement</li>
            </ul>
        </div>

        <!-- Section 9: Limitation of liability -->
        <div class="terms-section" id="section9">
            <h2><span class="section-number">9.</span>Limitation of liability</h2>

            <h3>a. Scope of limitation</h3>
            <p>In all cases and to the maximum extent permitted by law, VietQubit, its members, employees, and partners shall not be liable for:</p>
            <ul>
                <li>Any direct, indirect, incidental, special, or consequential damages</li>
                <li>Loss of profits, data, or business opportunities</li>
                <li>Costs of procuring substitute goods or services</li>
                <li>Damages resulting from viruses, malware, or cyberattacks</li>
            </ul>

            <p>Even if VietQubit has been advised of the possibility of such damages.</p>

            <h3>b. Basis of the bargain</h3>
            <p>You understand and agree that these limitations of liability reflect a reasonable allocation of risk between the parties and form an essential basis of the agreement between you and VietQubit.</p>
        </div>

        <!-- Section 10: Indemnification -->
        <div class="terms-section" id="section10">
            <h2><span class="section-number">10.</span>Indemnification</h2>

            <p>You agree to defend, indemnify, and hold harmless VietQubit, its affiliates, directors, employees, and agents from and against any claims, damages, losses, liabilities, costs, and expenses (including reasonable attorneys' fees) arising out of or related to:</p>

            <ul>
                <li>Your breach of these Terms</li>
                <li>Your violation of any third-party rights</li>
                <li>Your misuse of the Website or services</li>
                <li>Content you submit, upload, or share through the Website</li>
            </ul>

            <p>Your indemnification obligations will survive the termination of these Terms.</p>
        </div>

        <!-- Section 11: Termination of use -->
        <div class="terms-section" id="section11">
            <h2><span class="section-number">11.</span>Termination of use</h2>

            <h3>a. VietQubit's right to terminate</h3>
            <p>We reserve the right, at our sole discretion, to:</p>
            <ul>
                <li>Temporarily suspend or permanently terminate your access to the Website</li>
                <li>Remove content that violates these Terms or applicable laws</li>
                <li>Take legal action where necessary</li>
            </ul>

            <p>Termination may occur immediately in the event of a serious breach of these Terms, or with notice in other cases as we deem appropriate.</p>

            <h3>b. Your rights</h3>
            <p>You may stop using the Website at any time. If you wish to have your personal data deleted, please contact us as described in the Personal Data Protection section.</p>

            <h3>c. Effect of termination</h3>
            <p>Provisions relating to intellectual property, limitation of liability, indemnification, and any other provisions that by their nature should survive termination shall continue in full force and effect.</p>
        </div>

        <!-- Section 12: Changes to the terms -->
        <div class="terms-section" id="section12">
            <h2><span class="section-number">12.</span>Changes to the terms</h2>

            <h3>a. Right to modify</h3>
            <p>VietQubit reserves the right to update or modify these Terms at any time in order to:</p>
            <ul>
                <li>Comply with changes in the law</li>
                <li>Reflect updates or changes in our services</li>
                <li>Improve clarity or correct errors</li>
                <li>Better protect user rights</li>
            </ul>

            <h3>b. Notice of changes</h3>
            <p>When material changes are made, we will:</p>
            <ul>
                <li>Update the "Last updated" date at the top of the page</li>
                <li>Display a notice on the Website</li>
                <li>Send you an email notification, if you have subscribed</li>
            </ul>

            <p>Your continued use of the Website after the changes take effect will constitute your acceptance of the revised Terms.</p>
        </div>

        <!-- Section 13: Governing law and Dispute resolution -->
        <div class="terms-section" id="section13">
            <h2><span class="section-number">13.</span>Governing law and Dispute resolution</h2>

            <h3>a. Governing law</h3>
            <p>These Terms are governed by and construed in accordance with:</p>
            <ul>
                <li>The laws of Vietnam as the primary governing law</li>
                <li>GDPR for users located in the EU/EEA</li>
                <li>Relevant local laws of the user's country where required</li>
            </ul>

            <p>In the event of a conflict between legal systems, we will apply the framework that provides the highest level of protection for users, where applicable.</p>

            <h3>b. Dispute resolution</h3>
            <p>We believe that disputes are best resolved through dialogue:</p>

            <div class="step-process">
                <div class="step">
                    <h4>Step 1: Direct negotiation</h4>
                    <ul>
                        <li>Contact us at <u>legal@vietqubit.com</u></li>
                        <li>We aim to respond within 15 business days</li>
                        <li>We will work with you in good faith to find a mutually satisfactory solution</li>
                    </ul>
                </div>

                <div class="step">
                    <h4>Step 2: Mediation</h4>
                    <ul>
                        <li>If negotiation fails, the parties may agree to mediation</li>
                        <li>Mediation costs may be shared equally by the parties</li>
                    </ul>
                </div>

                <div class="step">
                    <h4>Step 3: Competent courts</h4>
                    <ul>
                        <li>Courts located in Ho Chi Minh City, Vietnam shall have jurisdiction</li>
                        <li>Users in the United States or the EU may have the right to bring claims before their local courts, in accordance with applicable law</li>
                    </ul>
                </div>
            </div>

            <h3>c. Right to complain for U.S. and EU users</h3>
            <p>Users in the United States or the European Union may have the right to lodge a complaint with their local data protection authority if they believe their rights have been violated.</p>
        </div>

        <!-- Section 14: Miscellaneous -->
        <div class="terms-section" id="section14">
            <h2><span class="section-number">14.</span>Miscellaneous</h2>

            <h3>a. Entire agreement</h3>
            <p>These Terms, together with our Privacy Policy, constitute the entire agreement between you and VietQubit regarding your use of the Website and supersede any prior agreements or understandings relating to the subject matter.</p>

            <h3>b. Severability</h3>
            <p>If any provision of these Terms is held invalid or unenforceable by a court of competent jurisdiction, the remaining provisions shall remain in full force and effect. The invalid provision will be deemed modified to the minimum extent necessary to make it valid and enforceable.</p>

            <h3>c. No waiver</h3>
            <p>The failure or delay of VietQubit to exercise any right or remedy under these Terms shall not be deemed a waiver of such right or remedy. Any waiver must be in writing and signed by an authorized representative of VietQubit.</p>

            <h3>d. Assignment</h3>
            <p>You may not assign or transfer any of your rights or obligations under these Terms to any third party without VietQubit’s prior written consent. VietQubit may assign its rights and obligations under these Terms without your consent.</p>

            <h3>e. Notices</h3>
            <p>All notices under these Terms shall be given as follows:</p>
            <ul>
                <li>To VietQubit: By email to <u>legal@vietqubit.com</u> or to the address published on the Website</li>
                <li>To you: By email to the address you provide, or via notifications displayed on the Website</li>
            </ul>

            <h3>f. Binding effect</h3>
            <p>These Terms are binding upon and shall inure to the benefit of the parties and their respective successors and permitted assigns.</p>
        </div>

        <!-- Section 15: Contact information -->
        <div class="terms-section" id="section15">
            <h2><span class="section-number">15.</span>Contact information</h2>
            <p>We are always ready to listen and assist you. If you have any questions, comments, or concerns regarding these Terms of Use, please contact us:</p>

            <div class="contact-info">
                <h3>General information</h3>
                <p><strong>VietQubit Research Center</strong></p>
                <ul>
                    <li>Website: <u>https://vietqubit.com</u></li>
                    <li>General email: <u>contact@vietqubit.com</u></li>
                    <li>Legal email: <u>legal@vietqubit.com</u></li>
                </ul>
            </div>

            <div class="contact-info">
                <h3>Data protection matters</h3>
                <p><strong>Data Protection Officer (DPO)</strong></p>
                <ul>
                    <li>Privacy email: <u>privacy@vietqubit.com</u></li>
                </ul>
            </div>

            <div class="response-time">
                <h4>Business hours and response time</h4>
                <ul>
                    <li><strong>Business hours:</strong> Monday – Friday: 9:00 – 17:00 (GMT+7)</li>
                    <li><strong>Closed:</strong> Saturdays, Sundays, and public holidays</li>
                    <li><strong>Typical response time:</strong> 3 – 5 business days</li>
                    <li><strong>Urgent matters:</strong> 24 – 72 hours</li>
                </ul>
            </div>
        </div>

        <!-- Section 16: Closing statement -->
        <div class="terms-section" id="section16">
            <h2><span class="section-number">16.</span>Closing statement</h2>
            <p>Thank you for taking the time to read our Terms of Use. We recognize that this is a lengthy document, but understanding the rights and responsibilities of both parties is essential to building a trusting relationship.</p>

            <div class="commitment-box">
                <h3>VietQubit is committed to:</h3>
                <ul>
                    <li>Maintaining transparency in all activities</li>
                    <li>Respecting your privacy and personal data</li>
                    <li>Providing high-quality content to the community</li>
                    <li>Listening to and improving based on user feedback</li>
                </ul>
            </div>

            <p>We believe that AI can bring about positive change for society, and we are honored to have you accompany us on this journey.</p>

            <div class="highlight-box">
                <h4>The future of AI in Vietnam</h4>
                <p>With the support of a community like you, we are confident that Vietnam can become a leading hub for AI research in the region and around the world.</p>
            </div>
        </div>
    `;
  };

  return {
    content,
  };
}
